import { DocumentStorageContextProvider } from 'framework/documentStorage';
import React from 'react';
import useComplianceDocumentService from './useComplianceDocumentService';

const ComplianceDocumentContext = ({ children }: { children: React.ReactNode }) => {
  const actions = useComplianceDocumentService();

  return <DocumentStorageContextProvider value={actions}>{children}</DocumentStorageContextProvider>;
};

export default ComplianceDocumentContext;
